import { useEffect } from "react";

import { sendTelemetryEvent } from "@/lib/telemetry";
import type { QuerySmMax } from "@/styles/tokens.stylex";
import {
    type PropsTelemetryCustom,
    getFromUrl,
    jumpToSectionId,
    removeFromUrl,
} from "@Components/Modules/Helpers";
import { scrollToCbFAQ } from "@Constants/PortalConstants";
import * as stylex from "@stylexjs/stylex";

import ExpandableListItem from "../../common/ExpandableListItem";
import QuestionBalloonIcon from "./icons/QuestionBalloonIcon";

import * as css from "./CashbackFAQ.module.css";

export interface ICashbackFAQ {
    frequentQuestionsList: IFaqQuestionAnswers[];
    scrollToCustomId?: string;
}

export interface IFaqQuestionAnswers extends PropsTelemetryCustom {
    itemId: string;
    question: string;
    answer: string;
    dataTestId?: string;
    onExpand?: (isExpanded: boolean) => void;
}

const cashbackFaqId = "cashback-faq";

export default function CashbackFAQ(props: ICashbackFAQ) {
    useEffect(() => {
        if (getFromUrl(scrollToCbFAQ) === "true") {
            const idToScroll = props?.scrollToCustomId || cashbackFaqId;
            jumpToSectionId(idToScroll);
            removeFromUrl(scrollToCbFAQ);
        }
    }, []);

    return (
        <div className={css.cashbackFaqComponent} id={cashbackFaqId}>
            <QuestionBalloonIcon styleX={styles.faqIcon} />
            <div className={css.faqList}>
                {props.frequentQuestionsList?.map((faq: IFaqQuestionAnswers) => (
                    <ExpandableListItem
                        key={faq.itemId}
                        linkElement={{
                            text: faq.question,
                            hideLoading: true,
                            telemetryCustom: faq.telemetryCustom,
                            dataTestId: faq.dataTestId,
                        }}
                        expandableElement={faq.answer}
                        onExpand={(isExpanded) => {
                            sendTelemetryEvent({
                                eventName: "cshbck-SampleFaq",
                                actionType: "Click",
                                param1: faq.itemId,
                                param2: `${isExpanded}`,
                            });
                        }}
                        isStructuredData
                    />
                ))}
            </div>
        </div>
    );
}

const smMax: QuerySmMax = "@media (max-width: 989px)";

const styles = stylex.create({
    faqIcon: {
        display: "block",
        position: "relative",
        transform: {
            default: "translateY(-35%)",
            [smMax]: "translateY(-20%)",
        },
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 0,
        width: "120px",
    },
});
